import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { FlagsManager } from "@/features/admin/components/flags-manager";
import { MaintenancePanel } from "@/features/admin/components/maintenance-panel";
import { PageContainer } from "@fleet/ui";

function AdminFlagsPage() {
  return (
    <PageContainer maxWidth="5xl">
      {/*
        El modo mantenimiento se guarda en la MISMA tabla que los flags
        (`system.maintenance`) pero tiene endpoint propio: accionarlo se audita y
        el CRUD genérico rechaza las claves `system.*` para que no haya puerta de
        atrás sin rastro. Comparte pantalla por eso, no por casualidad.
      */}
      <div class="space-y-10">
        <MaintenancePanel />
        <FlagsManager />
      </div>
    </PageContainer>
  );
}

export const adminFlagsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/flags",
  component: AdminFlagsPage,
});
